// Types for the async bulk offer-update flow (see OfferUpdateController on the API).

export enum OfferUpdateType {
  BestOfferReset = 0,
  Title = 1,
  Policy = 2,
  Description = 3,
  ConditionDescription = 4,
}

// Returned immediately when any offer-update is queued.
export interface IOfferUpdateQueueResult {
  batchId: string | null;
  queued: number;
  skipped: number;
}

export type OfferUpdateItemStatus = "Pending" | "Processing" | "Success" | "Failed";

export interface IOfferUpdateBatchItemStatus {
  id: string;
  type: OfferUpdateType;
  partOfferId: string;
  partDataId: string;
  sku: string | null;
  title: string | null;
  newAutoAcceptPrice: number | null;
  isProcessing: boolean;
  isSuccess: boolean;
  errorMessage: string | null;
  status: OfferUpdateItemStatus;
}

// Admin > Replace eBay Policy. Values match EbayPolicyKind on the API.
export enum EbayPolicyKind {
  Postage = 0,
  Payment = 1,
  Returns = 2,
}

// A policy unsold parts are on, read from Wilma's own offers - so it can be one already deleted on eBay.
export interface IPolicyInUse {
  policyId: string;
  name: string | null;
  offers: number;
}

export interface IPolicyReplacementPreview {
  liveListings: number;
  otherOffers: number;
  categoryDefaults: number;
  leftAlone: number;
  shopifyMappingMissing: boolean;
}

export interface IPolicyReplacementResult extends IPolicyReplacementPreview {
  batchId: string | null;
  // Set by the page, not the API: the run was "Test with 5" rather than the whole stock.
  trial?: boolean;
}

export interface IOfferUpdateBatchStatus {
  batchId: string;
  type: OfferUpdateType;
  isComplete: boolean;
  total: number;
  succeeded: number;
  failed: number;
  processing: number;
  pending: number;
  items: IOfferUpdateBatchItemStatus[];
}
